module.exports = __webpack_public_path__ + "img/logo-partners.e144184f.svg";